import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Division from './Division';
var League = function League(_ref) {
  var _classnames;
  var league = _ref.league,
    navPosition = _ref.navPosition;
  var divisions = league.divisions.map(function (division) {
    return /*#__PURE__*/React.createElement("div", {
      className: "header__subnav__group header__subnav--teams__division",
      key: "".concat(league.name, " ").concat(division.name)
    }, /*#__PURE__*/React.createElement(Division, {
      division: division,
      navPosition: navPosition
    }));
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classnames((_classnames = {}, _defineProperty(_classnames, 'header__subnav--teams__league', true), _defineProperty(_classnames, 'header__subnav--teams__league--home-link', league.isHomeLink), _classnames))
  }, /*#__PURE__*/React.createElement("div", {
    className: "header__subnav--teams__divisions"
  }, divisions));
};
export default League;
League.propTypes = {
  league: PropTypes.shape({
    divisions: PropTypes.array,
    name: PropTypes.string,
    isHomeLink: PropTypes.bool
  }).isRequired,
  navPosition: PropTypes.string
};